import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import { ref, onMounted } from "vue";
import { useGlobalStore } from "../stores/global";
import { useGameTracking } from "@/composables/useGameTracking";
import { checkAndConsumeDailyPlay } from "@/services/pimPlayLimit";


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayButton',
  setup(__props) {

const globalStore = useGlobalStore();
const { kpiTracker, session } = useGameTracking();
const animate = ref(false);
const isCheckingPlayLimit = ref(false);

const handleButtonClick = async () => {
  if (kpiTracker.selectedPerson.value === 0 || isCheckingPlayLimit.value) {
    return;
  }

  if (!globalStore.legalConditionsAccepted) {
    globalStore.changeStep("termsAcceptance");
    return;
  }

  isCheckingPlayLimit.value = true;

  try {
    const campaignId =
      new URL(location.href).searchParams.get("campaignId") ?? "";
    const playLimitResult = await checkAndConsumeDailyPlay({
      participantKey: session.fingerprint.value || undefined,
      campaignId,
    });
    globalStore.setRemainingDailyPlays(playLimitResult.remainingPlays);
    globalStore.setShouldShowDailyLimitScreen(
      playLimitResult.remainingPlays === 0
    );

    if (!playLimitResult.allowed) {
      globalStore.setTimesLeftToPlay(0);
      globalStore.changeStep("thatsEnough");
      return;
    }
  } catch (error) {
    console.error("[PlayButton] Error while checking PIM play limit:", error);
    globalStore.setShouldShowDailyLimitScreen(false);
  } finally {
    isCheckingPlayLimit.value = false;
  }

  globalStore.setRaffleResult(null);

  // Start tracking game play time from the moment user clicks Play button
  kpiTracker.setGamePlayTimeStart(Date.now());

  // Set progress to 2 (game_started) when user clicks Play button
  // This triggers game_started_count++ on the backend
  kpiTracker.setProgress(2);

  // Update session with progress "game_started" to trigger game_started_count++
  console.log("[PlayButton] Updating session with progress 'game_started' (game_started_count will be incremented by backend)");
  try {
    await session.updateSessionProgress(kpiTracker.getKpiData(), { step: "game_started" });
    console.log("[PlayButton] Session update completed");
  } catch (error) {
    console.error("[PlayButton] Error updating session:", error);
  }
  
  globalStore.changeStep("gameMove");
};

onMounted(() => {
  setTimeout(() => {
    animate.value = true;
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'cursor-not-allowed':
        _unref(kpiTracker).selectedPerson.value === 0 || isCheckingPlayLimit.value,
      'opacity-50': _unref(kpiTracker).selectedPerson.value === 0 || isCheckingPlayLimit.value,
    })
  }, [
    _createElementVNode("button", {
      class: _normalizeClass(["w-full py-3 text-sm font-bold text-center text-white uppercase rounded-xl bg-jm_orange play-button", { 'animate-play-button': animate.value }]),
      onClick: handleButtonClick,
      disabled: _unref(kpiTracker).selectedPerson.value === 0 || isCheckingPlayLimit.value
    }, _toDisplayString(_ctx.$t("age_check.play_button")), 11, _hoisted_1)
  ], 2))
}
}

})